import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  tiendaObtener,
  clienteObtenerClientes,
  tiendaActualizarEmailMarketing,
  clienteExportarNuevosSuscriptores,
} from '../../store/actions';
import {
  Grid,
  withStyles,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Icon,
} from '@material-ui/core';
import { ButtonUI, AlertUI, ModuleTitleUI, ToggleUI } from '../common';
import { WrapperLayout } from '../../layouts/WrapperLayout';

class EmailMarketing_ extends Component {
  state = {
    loading: {
      email_marketing: true,
      clientes: true,
      error: false,
    },
    forms: {
      email_marketing: false,
      exportar_todos: false,
      exportar_nuevos: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  componentDidMount() {
    this.props.tiendaObtener((err, resp) => {
      this.setState({
        loading: {
          ...this.state.loading,
          email_marketing: false,
          error: err || this.state.loading.error ? true : false,
        },
      });
    });
    this.props.clienteObtenerClientes(
      {
        cl_bloqueado: 0,
      },
      (err, resp) => {
        this.setState({
          loading: {
            ...this.state.loading,
            clientes: false,
            error: err || this.state.loading.error ? true : false,
          },
        });
      }
    );
  }

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      forms: {
        ...this.state.forms,
        email_marketing: true,
      },
    });

    this.props.tiendaActualizarEmailMarketing(
      {
        t_email_marketing: this.props.tienda.t_email_marketing ? 0 : 1,
      },
      (err, resp) => {
        this.setState({
          forms: {
            ...this.state.forms,
            email_marketing: false,
          },
          alert: {
            ...this.state.alert,
            open: true,
            message: resp.message,
            type: err ? 'error' : 'success',
          },
        });
      }
    );
  };

  generateTXT = (clientes, filename) => {
    let list = '';
    clientes.forEach((cliente) => {
      list += cliente.cl_email + '\n';
    });
    let data = new Blob([list], { type: 'text/plain' });
    let anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(data);
    anchor.download = filename + '.txt';
    anchor.click();
  };

  handleSubmitExportarNuevos = (e) => {
    e.preventDefault();
    this.setState({
      forms: {
        ...this.state.forms,
        exportar_nuevos: true,
      },
    });

    let clientes_nuevos = this.props.clientes.filter((cliente) => {
      return cliente.cl_exportado === 0;
    });

    if (clientes_nuevos.length) {
      this.props.clienteExportarNuevosSuscriptores((err, resp) => {
        if (err) {
          this.setState({
            forms: {
              ...this.state.forms,
              exportar_nuevos: false,
            },
            alert: {
              ...this.state.alert,
              open: true,
              message: resp.message,
              type: 'error',
            },
          });
        } else {
          this.setState({
            forms: {
              ...this.state.forms,
              exportar_nuevos: false,
            },
          });
          this.generateTXT(clientes_nuevos, 'nuevos_suscriptores');
        }
      });
    } else {
      this.setState({
        forms: {
          ...this.state.forms,
          exportar_nuevos: false,
        },
      });
    }
  };

  handleSubmitExportarTodos = (e) => {
    e.preventDefault();
    this.setState({
      forms: {
        ...this.state.forms,
        exportar_todos: true,
      },
    });
    this.generateTXT(this.props.clientes, 'todos_los_suscriptores');
    this.setState({
      forms: {
        ...this.state.forms,
        exportar_todos: false,
      },
    });
  };

  render() {
    let { classes } = this.props;

    let cantidad_clientes = this.props.clientes.length;
    let cantidad_clientes_sin_exportar = this.props.clientes.filter(
      (cliente) => cliente.cl_exportado === 0
    ).length;

    return (
      <WrapperLayout
        loading={
          this.state.loading.email_marketing || this.state.loading.clientes
        }
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <ModuleTitleUI
              title="Email marketing"
              subtitles={[
                'El email marketing es una herramienta de comunicación directa con tus clientes a través de correo electrónico. Podes enviar comunicaciones, promociones, informar sobre un nuevo artículo en tu blog, etc.',
                'En esta sección vas a poder exportar la lista de contactos de tu newsletter (suscripciones) o de tus clientes para luego utilizarlas en tu plataforma de email marketing preferida (Por ejemplo: Envialo simple, Doppler, Mailchimp, etc).',
              ]}
              button={
                <ButtonUI
                  type="callf"
                  label={
                    this.props.tienda.t_email_marketing
                      ? 'Desactivar'
                      : 'Activar'
                  }
                  fullWidth={false}
                  onClickFunc={this.handleSubmit}
                  isLoading={this.state.forms.email_marketing}
                />
              }
            />
          </Grid>
          <ToggleUI show={this.props.tienda.t_email_marketing ? true : false}>
            <Grid item md={6} xs={12}>
              <Card className={classes.card}>
                <CardHeader
                  classes={{
                    root: classes.card_header,
                    title: classes.card_header_title,
                    action: classes.card_action_button,
                  }}
                  action={
                    <Chip
                      component="div"
                      color="primary"
                      label={
                        cantidad_clientes_sin_exportar === 1
                          ? cantidad_clientes_sin_exportar + ' Nuevo'
                          : cantidad_clientes_sin_exportar + ' Nuevos'
                      }
                    />
                  }
                  title="Nuevos suscriptores"
                />
                <CardContent className={classes.card_content}>
                  <Grid container spacing={24}>
                    <ButtonUI
                      type="callf"
                      label={
                        <div className={classes.icon_center}>
                          <Icon className={classes.icon_badge}>
                            cloud_download
                          </Icon>{' '}
                          EXPORTAR
                        </div>
                      }
                      onClickFunc={this.handleSubmitExportarNuevos}
                      isLoading={this.state.forms.exportar_nuevos}
                      disabled={cantidad_clientes_sin_exportar === 0}
                    />
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} xs={12}>
              <Card className={classes.card}>
                <CardHeader
                  classes={{
                    root: classes.card_header,
                    title: classes.card_header_title,
                    action: classes.card_action_button,
                  }}
                  action={
                    <Chip
                      component="div"
                      color="primary"
                      label={cantidad_clientes}
                    />
                  }
                  title="Todos los suscriptores"
                />
                <CardContent className={classes.card_content}>
                  <Grid container spacing={24}>
                    <ButtonUI
                      type="callf"
                      label={
                        <div className={classes.icon_center}>
                          <Icon className={classes.icon_badge}>
                            cloud_download
                          </Icon>{' '}
                          EXPORTAR
                        </div>
                      }
                      onClickFunc={this.handleSubmitExportarTodos}
                      isLoading={this.state.forms.exportar_todos}
                      disabled={cantidad_clientes === 0}
                    />
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </ToggleUI>
        </Grid>
      </WrapperLayout>
    );
  }
}

const styles = (theme) => ({
  card: theme.card.card,
  card_header: theme.card.card_header,
  card_header_title: {
    ...theme.card.card_header_title,
    fontSize: '1.3rem',
  },
  card_content: theme.card.card_content,
  card_actions: theme.card.card_actions_public,
  card_subheader: theme.card.card_subheader,
  card_subheader_icon: theme.card.card_subheader_icon,
  card_action_button: theme.card.card_action_button,
  icon_center: {
    display: 'flex',
    alignItems: 'center',
  },
  icon_badge: {
    marginRight: '5px',
  },
  chip: theme.chip,
});

const mapStateToProps = (state) => {
  return {
    tienda: state.tienda,
    clientes: state.clientes,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    tiendaObtener: (callback) => dispatch(tiendaObtener(callback)),
    clienteObtenerClientes: (data, callback) =>
      dispatch(clienteObtenerClientes(data, callback)),
    tiendaActualizarEmailMarketing: (data, callback) =>
      dispatch(tiendaActualizarEmailMarketing(data, callback)),
    clienteExportarNuevosSuscriptores: (callback) =>
      dispatch(clienteExportarNuevosSuscriptores(callback)),
  };
};

export const EmailMarketing = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(EmailMarketing_)
);
